import DSCircularProgress from '../../design-system/DSCircularProgress';
import DSBox from '../../design-system/DSBox';
import bg from '../../images/darkSplashScreen.png';
import { KLYDO_BLACK, KLYDO_YELLOW } from '../../consts/colors';
import GreetLogo from './GreetLogo';

export function GreetSplashScreen() {
  return (
    <div
      id="fuse-splash-screen"
      style={{ background: KLYDO_BLACK, backgroundImage: `url(${bg})` }}
    >
      <div className="center">
        <DSBox sx={{ width: 140, margin: '0 auto' }}>
          <GreetLogo color={KLYDO_YELLOW} width={140} />
        </DSBox>
        <DSBox
          sx={{
            paddingTop: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <DSCircularProgress />
        </DSBox>
      </div>
    </div>
  );
}
